import {ROW_TYPE_THRESHOLDS} from '../constants/categoryMapping';
import {RowType} from '../schemas';

/**
 * Determine row type based on will_need and confidence
 */
export function getRowType(will_need: boolean, confidence: number): RowType {
  if (!will_need) {
    return 'suggestions';
  }

  if (confidence >= ROW_TYPE_THRESHOLDS.DAMAGE) {
    return 'damage';
  }

  if (confidence >= ROW_TYPE_THRESHOLDS.SERVICE) {
    return 'service';
  }

  return 'suggestions';
}
